import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { resetScroll } from "../hooks/useSmoothScroll";

/**
 * Resets scroll position on navigation.
 *
 * A client-side route change swaps the DOM but leaves window.scrollY alone, so
 * clicking a project from #work (already far down the page) landed on the
 * detail page at that same offset -- appearing to open at the bottom.
 *
 * Two cases deliberately keep their position:
 *  - POP (browser back/forward), where restoring where the viewer was is right.
 *  - Any URL carrying a hash, e.g. the "/#work" back-link, which must land on
 *    the anchor rather than the top of the page.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  // Layout effect so the jump happens before paint, with no visible flash.
  useLayoutEffect(() => {
    if (hash || navigationType === "POP") return;
    resetScroll();
  }, [pathname, hash, navigationType]);

  return null;
}
